import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import imgf1 from "../assets/imgs/feature1img.png"
import imgf2 from "../assets/imgs/feature2img.png"
import imgf3 from "../assets/imgs/feature3img.png"
import imgf4 from "../assets/imgs/feature4img.png"
import "./AboutFeatures.css"



const AboutFeature = () => {
    return (
        <Container className="mt-5">
            <h1 className="text-center">Features</h1>
            <Row className="features-row-last">
                <Col xs={12} md={6}>
                    <img src={imgf1} alt="Feature 1" className="img-fluid" />
                </Col>
                <Col xs={12} md={6}>
                    <div className="text-center text-md-start features-text">
                        <h3>High-Quality Product</h3>
                        <p>
                            Elevate Your Brand with Pristine Precision! Our graphics design creations are meticulously crafted, ensuring every pixel and every line speaks volumes of quality. Dive into a world where excellence is the baseline, and breathtaking visuals are the norm.
                        </p>
                    </div>
                </Col>
            </Row>
            <Row className="features-row">
                <Col xs={12} md={6} >
                    <div className="text-center text-md-start features-text">
                        <h3>Personalized Design</h3>
                        <p>
                            Your Vision, Tailored to Perfection! At the heart of our service lies the promise of personalized design – a bespoke solution that captures your unique essence. Our designers are not just creators; they are visual translators turning your ideas into stunning graphic realities.
                        </p>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <img src={imgf2} alt="Feature 2" className="img-fluid" />
                </Col>
            </Row>
            <Row className="features-row-last">
                <Col xs={12} md={6}>
                    <img src={imgf3} alt="Feature 3" className="img-fluid" />
                </Col>
                <Col xs={12} md={6}>
                    <div className="text-center text-md-start features-text">
                        <h3>On Time Delivery</h3>
                        <p>
                            When Every Second Counts, Trust Us to Deliver! We understand the value of time in the fast-paced digital world. Our commitment to on-time delivery means your projects flow smoothly, without a hitch, ensuring your deadlines are met with room to breathe.
                        </p>
                    </div>
                </Col>
            </Row>
            <Row className="features-row">
                <Col xs={12} md={6}>
                    <div className="text-center text-md-start features-text ">
                        <h3>100% Customer Satisfaction</h3>
                        <p>
                            Your Happiness, Our Creed! We're not just about creating designs; we're about crafting joy. With a steadfast commitment to 100% customer satisfaction, we go the extra mile to ensure every detail resonates with your expectations. Experience the bliss of seamless collaboration and results that not only meet but exceed your desires.
                        </p>
                    </div>
                </Col>
                <Col xs={12} md={6}  >
                    <img src={imgf4} alt="Feature 4" className="img-fluid" />
                </Col>
            </Row>

        </Container>
    );
};

export default AboutFeature;
